<template>
  <div> 
    
    
    <Dialog header="Success" :visible.sync="displaySuccess" :style="{width: '500px'}" :modal="true">
        <div class="confirmation-content">
            <i class="pi pi-info-circle p-mr-3" style="font-size: 2rem" />
            <span>A new enquiry was saved successfully. The sQuote No is {{ savedSQuoteNo }}</span>
        </div>
        <template #footer>
          <Button label="Ok" icon="pi pi-check" @click="displaySuccess = false" class="p-button-text" autofocus />
          <Button 
            @click="displaySuccess = false; newQuote()"
            label="Book In"
          />
        </template>
    </Dialog>

    <crm-toolbar :dbView="101" :pageName="'enquirytab'" :customer="customer" @changeData="updateEnquiries"  @newInstance="newOpportunity" @fetchedColSelectedFields="updateColumns" @setDefaultViewFields="setDefaultViewFields"/>

    <OpportunityTable
      :dbView="dbViewE"
      :data="enquiries"
      :loading="loadingEnquiries"
      :dbViewFields="dbViewFieldsE"
      :colSelectedFields="colSelectedFieldsE"
      :colSelectedFieldsForTable="colSelectedFieldsForTableE"
      :reloadTable="reloadTableE"
      :colSelectedFieldsForTable1="colSelectedFieldsForTable"
      :opportunityStatuses="opportunityStatuses"
      :showExportButton="false"
      @editOpportunity="editOpportunity"
      @newQuote="newQuote"
      @deleteOpportunity="confirmDeleteOpportunity"
      @reload="getCustomerEqnuiries"
      @lazyNext="lazyNext"
      :totalRecords="totalRecords"
      :currentPage="currentPage"
      :rows="rows"
    />
    
    <!-- Enquiry form -->
    <OpportunityForm
      :key="enquiryFormKey"
      v-if="openOpportunityDialog"
      :onlyUserBranch="onlyUserBranch"
      :opportunityDialog="openOpportunityDialog"
      :opportunityToEdit="opportunityToEdit"
      :disabledArray="disabledArray"
      :colSelectedFieldsForTable="colSelectedFieldsForTable"
      @close="close"
      @save="savedOpportunity"
    />

    <QuotationForm
      :quotationDialog="quotationDialog"
      :opportunity="realOpportunity"
      :active="activeQuote"
      :quoteToEdit="quotation"
      :disabledArr="disabledArray"
      @close="close"
      @saved="saved"
    />

    <!-- Activity Form -->

    <duplicateTable
      v-if="colSelectedFieldsForTable"
      :duplicateDialog="displayDuplicateMessage"
      :colSelectedFieldsForTable="colSelectedFieldsForTable"
      :dataId="'oppId'"
      :name="'Enquiry'"
      :namePlural="'Enquiries'"
      :list="duplicates"
      :requesting="duplicateRequesting"
      @close="displayDuplicateMessage = false"
      @agree="sendDuplicate"
    />

  </div>
</template>
<script>
import CustomerService from "@/service/CustomerService";
import OpportunityService from "@/service/OpportunityService";
import QuotationService from "@/service/QuotationService";
import AttachmentService from "@/service/AttachmentService";
import UserService from "@/service/UserService";
import ActivityService from "@/service/ActivityService";
import FiltersService from "@/service/FiltersSerice";

import OpportunityForm from "@/mbp/universalComponents/opportunity/OpportunityForm.vue";
import OpportunityTable from "@/mbp/universalComponents/opportunity/OpportunityTableForLazyLoadingWithResize.vue";
import QuotationForm from "@/mbp/universalComponents/quotation/QuotationForm.vue";
import crmToolbar from '../../universalComponents/general/crmToolbar'

import duplicateTable from '../../universalComponents/opportunity/duplicateDialog'

export default {
  components: {
    OpportunityTable,
    OpportunityForm,
    QuotationForm,
    duplicateTable,
    crmToolbar
  },
  props: ["customer"],
  customerService: null,
  opportunityService: null,
  quotationService: null,
  attachmentService: null,
  userService: null,
  activityService: null,
  data: () => ({
    filtersService: new FiltersService(),
    
    openOpportunityDialog: false,
    realOpportunity: {},
    selectedCustomer: {},
    opportunityToEdit: {},
    disabledArray: [],
    displayDuplicateMessage: false,
    quotation: {},
    quotationDialog: false,

    searchText: '',
    totalRecords: null,
    totalPages: null,
    currentPage: 1,
    rows: 25,
    sortField: '',
    sortFieldId: 0,
    sortOrder: 0,

    disabledArr: [],
    activeQuote: false,
    
    onlyUserBranch: false,

    savedSQuoteNo: '',
    displaySuccess: false,
    duplicates: [],
    enquiryFormKey1: 0,
    
    dbView: 3, // for quotations I think
    colSelectedFields: [],
    colSelectedFieldsForTable: [],
    duplicateRequesting: false,
    dbViewFields: [],

    dbViewE: 101,
    colSelectedFieldsE: [],
    colSelectedFieldsForTableE: [],
    dbViewFieldsE: [],
    loadingEnquiries: false,
    enquiries: [],
    reloadTableE: 0,
    opportunityStatuses: [],
  }),
  computed: {
    myPermissions() {
        return this.$store.getters['auth/getUserPermissions']
    },
    enquiryFormKey: {
      set(val) {
        this.enquiryFormKey1++
      },
      get() {
        return 'enquiryFormKey-' + this.enquiryFormKey1.toString()
      }
    }
  },
  created() {
    this.customerService = new CustomerService();
    this.opportunityService = new OpportunityService()
    this.quotationService = new QuotationService();
    this.attachmentService = new AttachmentService();
    this.userService = new UserService();
    this.activityService = new ActivityService();
  },
  mounted() {

    this.getDBViewFieldsE()
    this.getColumnSelectionE()
    
    this.getAllActiveOpportunityStatuses()

    this.getDBViewFields()
    this.getColumnSelection()
  },
  watch: {
    currentPage(val) {
      if (val === 1) {
        this.reloadTableE++
      }
    },
    quotationDialog(val) {
      // 
      if (val && this.realOpportunity && this.realOpportunity.customer && this.realOpportunity.customer.requireApproval === true) {
        this.quotationDialog = false

        this.$toast.add({
          severity: "warn",
          summary: "Not allowed",
          detail: "Customer must be approved before Booking In the quotation",
          life: 5000,
        })
      }
    },
    dbViewFieldsE(val) {

      // 
      if (this.colSelectedFieldsForTableE.length < 1) {
        this.colSelectedFieldsForTableE = val.filter(a => a.defView)
      }
    },
    dbViewFields(val) {

      // 
      if (this.colSelectedFieldsForTable.length < 1) {
        this.colSelectedFieldsForTable = val.filter(a => a.defView)
      }
    },
    openOpportunityDialog(val) {
      if (val) {
        this.enquiryFormKey++
      }
    },
  },
  methods: {
    setDefaultViewFields(val) {
      this.colSelectedFieldsForTable = val.filter(a => a.defView)
    },
    updateEnquiries(obj) {
      this.loadingEnquiries = true
      if(obj && obj.quickFilters)
        obj.quickFilters["customer"] = this.$route.params.custid

      this.currentPage = obj.currentPage
      this.rows = obj.rows
      this.getDataFromSource(obj.savedFilter1,  obj.sortFieldId, obj.sortOrder, obj.query, obj.quickFilters)
    },
    getDataFromSource(savedFilter, sortFieldId, sortOrder, query, quickFilters) {
      this.opportunityService
        .getEnquiries(savedFilter, this.currentPage, this.rows, sortFieldId, sortOrder, query, quickFilters)
        .then(response => {
          this.totalRecords = parseInt(response.headers.reccount)
          this.loadingEnquiries = false
          this.enquiries = response.data                            

        })
        .catch(err => {
          this.loadingEnquiries = false              
                
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: `Error while getting enquiries for saved filter ${savedFilter1} and search text ${this.searchText}`,
            life: 5000,
          })
        })
    },
    lazyNext({ page, rows, totalPages }) {
      this.rows = rows
      this.totalPages = totalPages
      if (this.currentPage !== page) {
        this.currentPage = page
      }
      this.loadingEnquiries = true

      this.getDataFromSource(0, 0, 0, "*", {
        customer: this.$route.params.custid
      })
      
      
    },
    updateColumns(data) {
        this.colSelectedFieldsE = data
        this.setupColumnsE()
    },
    getDBViewFields() {
      this.filtersService
        .getDBViewFields(this.dbView)
        .then(data => this.dbViewFields = data)
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer DB view fields",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "dbViewFields/{dbView}"'
          })
        })
    },
    getDBViewFieldsE() {
      this.filtersService
        .getDBViewFields(this.dbViewE)
        .then(data => this.dbViewFieldsE = data)
        .catch(err => {
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "dbViewFields/{dbView}"'
          })
        })
    },
    getColumnSelectionE() {
      this.filtersService
        .getColumnSelection(this.dbViewE)
        .then(data => {
          this.colSelectedFieldsE = data
          this.setupColumnsE()
        })
        .catch(err => {
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "currentUserViewFields/{dbView}"'
          })
        })
    },
    getColumnSelection() {
      this.filtersService
        .getColumnSelection(this.dbView)
        .then(data => {
          this.colSelectedFields = data
          this.setupColumns()
        })
        .catch(err => {
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "currentUserViewFields/{dbView}"'
          })
        })
    },
    setupColumnsE() {

      let a = []
      this.colSelectedFieldsE.forEach(b => {
        // 
        let c = a.find(d => d.dbField === b.dbField.dbField)
        // 
        if (!a[b.colOrder - 1] && !c) {
          a[b.colOrder - 1] = { 
            ...b.dbField,
            defWidth: b.width
          }
        }
      })
      
      if (a.length) {
        this.colSelectedFieldsForTableE = a
      }
    },
    setupColumns() {

      let a = []
      this.colSelectedFields.forEach(b => {
        // 
        let c = a.find(d => d.dbField === b.dbField.dbField)
        // 
        if (!a[b.colOrder - 1] && !c) {
          a[b.colOrder - 1] = { 
            ...b.dbField,
            defWidth: b.width
          }
        }
      })
      
      if (a.length) {
        this.colSelectedFieldsForTable = a
      }
    },
    newQuote(opportunity) {
      
      
      this.disabledArray = [
        'opportunity',
        'mbpBranch',
        'Customer'
      ]
      // this.quotation = { ...this.opportunity, opportunity: this.opportunity };
      this.activeQuote = true
      this.quotationDialog = true;
    },
    getCustomerEqnuiries() {
      this.loadingEnquiries = true
      this.currentPage = 1
      this.opportunityService
        .getEnquiries(0, 1, 2000, 0, 0, '*', {
          customer: this.$route.params.custid
        })
        .then(response => {
          this.totalRecords = parseInt(response.headers.reccount)
          this.loadingEnquiries = false
          this.enquiries = response.data
        })
        .catch(err => {
          this.loadingEnquiries = false
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "opportunityfilterbypage2/0/1/2000/0/0/*"'
          })
        })
    },
    saved({ quote, file, params, active }) {
      
      this.activeQuote = false
      this.quotationDialog = false
      this.quotation = {};
      
      this.getCustomerEqnuiries()
    },
    close() {
      this.activeQuote = false
      this.quotationDialog = false
      
      this.openOpportunityDialog = false;
    },
    makeDuplicate(quote) {
      // 
      this.quotation = {};

      this.quotationService
        .getVersionNumber(quote.sQuoteNo, quote.opportunity && quote.opportunity.oppId)
        .then((response) => {
          this.quotation.versionNo = response
          this.quotation.createdByDept = quote.createdByDept
          this.quotation.customer = quote.customer
          this.quotation.dateCreated = quote.dateCreated
          this.quotation.expectedOrderDate = quote.expectedOrderDate
          this.quotation.expiryDate = quote.expiryDate
          this.quotation.mbpBranch = quote.mbpBranch
          this.quotation.notes = quote.notes
          this.quotation.dateCreated = quote.dateCreated
          this.quotation.opportunity = quote.opportunity
          this.quotation.productType = quote.productType
          this.quotation.quoteType = quote.quoteType
          this.quotation.reqDeliveryDate = quote.reqDeliveryDate
          this.quotation.sQuoteNo = quote.sQuoteNo

          this.disabledArray = [
            "Customer",
            "createdByDept",
            "expectedOrderDate",
            "mbpBranch",
            "notes",
            "opportunity",
            "productType",
            "reqDeliveryDate"
          ]
          this.activeQuote = true

          this.quotationDialog = true;
        })
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting quotation version number",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "quotenextverno/{sQuoteNo}"'
          })
        })
    },
    newOpportunity() {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'AddNewEnquiry');
      if (permission) {
          if (permission.permissionLevel === 0) {
          this.onlyUserBranch = false
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to create a new record",
            life: 5000,
          })
        } 
        else if (permission.permissionLevel === 1 || permission.permissionLevel === 4) {
          this.onlyUserBranch = false
          this.opportunityToEdit.customer = this.customer
          this.opportunityToEdit.country = 'UK'
          this.disabledArray = [
            'Customer'
          ]
          this.openOpportunityDialog = true
        } 
        else if (permission.permissionLevel === 5) {
          this.onlyUserBranch = true
          this.opportunityToEdit.customer = this.customer
          this.opportunityToEdit.country = 'UK'
          this.disabledArray = [
            'Customer'
          ]
          this.openOpportunityDialog = true
        }
      }
    },
    savedOpportunity(e) {
      
      this.realOpportunity = e.opportunity
      this.selectedCustomer = e.customer
      if (e.duplicates && e.duplicates.length) {
        this.duplicates = e.duplicates;
        this.displayDuplicateMessage = true
      } else {
        this.getCustomerEqnuiries()
        if (e.sQuoteNo) {
          this.savedSQuoteNo = e.sQuoteNo.sQuoteNo
          this.displaySuccess = true
        }
      }
    },
    sendDuplicate() {
      this.duplicateRequesting = true
      
      
      this.realOpportunity.custCode = this.selectedCustomer.custCode

      this.opportunityService
        .saveDuplicateOpportunity(this.realOpportunity)
        .then((response) => {
          this.duplicateRequesting = false
          this.displayDuplicateMessage = false
          
          
          this.realOpportunity = response.data;
          
          
          this.savedSQuoteNo = this.realOpportunity.sQuoteNo
          this.displaySuccess = true
          
          if (response.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: "New Enquiry Saved",
              detail: `new Enquiry was saved successfully, Quote No generated : ${this.realOpportunity.sQuoteNo}`,
              life: 5000,
            });
            this.openOpportunityDialog = false;
            
            this.getCustomerEqnuiries()
          }
        })
        .catch((e) => {
          this.duplicateRequesting = false
          this.displayDuplicateMessage = false
          

          if (e.response)                
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving enquiry",
              life: 5000,
            })
        })
    },
    getAllActiveOpportunityStatuses() {
      this.opportunityService
        .getAllActiveOpportunityStatuses()
        .then((data) => (this.opportunityStatuses = data))
        .catch(err => {
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "activeOpportunityStatuses"'
          })
        })
    },
    confirmDeleteOpportunity(data) {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'DeleteEnquiry');
      if (permission) {
          if (permission.permissionLevel === 0) {
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to delete an enquiry",
            life: 5000,
          })
        } else if (permission.permissionLevel === 1) {
            if (data && data.oppId) {
              this.opportunityService
                .deleteOpportunity(data.oppId)
                .then(() => {
                  this.reload()
                })
                .catch(error => {
                  this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: `The Enquiry was not deleted. Please ensure that there are no related records such as Quotations, Activities or Notes associated with the Opportunity. You can set the enquiry to cancelled instead.`,
                    life: 5000,
                  })
                })
            }
        }
      }
    },
    editOpportunity(opportunity) {
      

      if (
        opportunity && 
        !(
          opportunity.oppStatusName === "Cancelled" ||
          opportunity.oppStatusName === "Won" ||
          opportunity.oppStatusName === "Lost" ||
          opportunity.oppStatusName === "Expired"
        )
      ) {


        this.disabledArr = [
          // "Description",
          // "Address 1",
          // "Address 2",
          // "Address 3",
          // "City/Town",
          // "Post Code",
          "Country",
          // "Customer",
        ];

        if (opportunity.oppStatusName === 'Active') {
          this.disabledArr.push('Customer')
          this.disabledArr.push('mbpBranch')
        }

        this.opportunityToEdit = this.enquiries.find(o => o.oppId === opportunity.oppId)
        this.openOpportunityDialog = true;

      } else {
        if (opportunity && opportunity.oppStatusName) {
          this.$toast.add({
            severity: "warn",
            summary: "Can't edit",
            detail: "Sorry, you can't edit if the status is " + opportunity.oppStatusName,
            life: 5000,
          })
        } else {
          this.$toast.add({
            severity: "warn",
            summary: "Can't edit",
            detail: "Sorry, you can't edit the enquiry",
            life: 5000,
          })
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">

</style>